import { Col, Row } from "antd";
import Container from "components/container";
import { FC } from "react";

type Props = {
  className?: string;
};

const ScreenWithSidebar: FC<Props> = ({ className, children }) => {
  return (
    <div className={className}>
      <Container>
        <Row gutter={10}>
          <Col span={24}>{children}</Col>
        </Row>
      </Container>
    </div>
  );
};

export default ScreenWithSidebar;
